module.exports = __webpack_public_path__ + "img/icon-02.d4cab2ed.png";